import React from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, useSlug } from '@bloomberg/media-ui-core';

import styles from './SecurityName.module.css';

export type Size = 'small' | 'default' | 'large' | 'extraLarge';

export interface SecurityNameProps extends GlobalProps {
  anchorOnClick?: React.MouseEventHandler;
  anchorTarget?: string;
  className?: string;
  name?: string;
  securityName: string;
  size?: Size;
  url?: string;
  isDark?: boolean;
}

export const SecurityName = React.forwardRef<HTMLDivElement, SecurityNameProps>(
  function SecurityNameComponent(props: SecurityNameProps, ref) {
    const {
      anchorOnClick,
      anchorTarget = '_parent',
      name = 'SecurityName',
      securityName,
      size = 'default' as Size,
      url,
      isDark = false,
    } = props;

    const componentName = useSlug(name);
    const cx = classes(
      [styles.securityName, styles[size], isDark && styles.isDark],
      props
    );

    return (
      <div className={cx} ref={ref} data-component={componentName}>
        {url ? (
          <a
            href={url}
            target={anchorTarget}
            rel="noopener"
            className={styles.link}
            onClick={anchorOnClick}
          >
            {securityName}
          </a>
        ) : (
          securityName
        )}
      </div>
    );
  }
);
